// extracted by mini-css-extract-plugin
export default {"fase":"StepSchedule_fase__fWrej","horarios":"StepSchedule_horarios__istXu","cardTreino":"StepSchedule_cardTreino__QfvHe","avancar":"StepSchedule_avancar__fSpmK"};